import EAFieldset from "../../EAFieldset";
import EAButtonBar from "../../EAButtonBar";
import EAButton from "../../EAButton";
import React, {useEffect, useState} from "react";
import {useHttp} from "../../../services/HttpService";
import {
    getBetreiberByBetriebstypEndpoint, getBetreiberEndpoint,
    getBetreiberPersonalisiertEndpoint
} from "../../../services/OrganisationsService";
import {getBetriebsTypEndpoint} from "../../../services/WertelistenService";
import {personalisierungEndpoint} from "../../../services/AnwenderService";
import ErweiterteSucheJahresbericht from "./ErweiterteSucheJahresbericht";

export default function JahresberichtArbeitsListeSuche({
                                                        id,
                                                        formFactory,
                                                        attr,
                                                        sharedFilter,
                                                        onErweiterteSucheOpenChanged,
                                                        sharedFormFactory,
                                                        regionalstelleOptionen,
                                                        raeumlichesKriteriumOptionen,
                                                        behoerdeOptionen,
                                                        storedFilter,
                                                        setStoredFilter,
                                                        setFilter,
                                                        filter,
                                                        setSelected,
                                                        executeSearch,
                                                        initialSearchParameters
                                                    }) {
    const filterFieldId = "messstellebezeichnung-filter";

    const [betriebstyp, setBetriebstyp] = useState();
    const [organisationOptionen] = useHttp(getEndpoint());
    const [betriebTypOptionen] = useHttp(getBetriebsTypEndpoint);

    const [personalisierungsfilter] = useHttp(personalisierungEndpoint);
    const [betriebstypPersonalisiert, setBetriebstypPersonalisiert] = useState(false);

    function getEndpoint() {
        if (sharedFilter.personalisiert) {
            return getBetreiberPersonalisiertEndpoint;
        }
        else if (betriebstyp) {
            return getBetreiberByBetriebstypEndpoint(betriebstyp);
        }
        else {
            return getBetreiberEndpoint;
        }
    }

    useEffect(() => {
        if (filter.betriebTyp) {
            setBetriebstyp(filter.betriebTyp.id);
        }
    }, [organisationOptionen, filter.betriebTyp]);

    useEffect(() => {
        let newBetriebstypValue = false;

        if (personalisierungsfilter.data) {
            if (personalisierungsfilter.data.betriebstyp && sharedFilter.personalisiert) {
                newBetriebstypValue = true;
            }
        }

        setBetriebstypPersonalisiert(newBetriebstypValue);
    }, [sharedFilter.personalisiert, personalisierungsfilter.data]);

    function filterBetreiber(betriebstyp) {
        if (betriebstyp) {
            setBetriebstyp(betriebstyp.id);
        }
        else {
            setBetriebstyp(null);
        }
    }

    return (
        <EAFieldset id={id} caption="Suche">
            <div className="simpleFilter gridl">
                {formFactory.renderAutocomplete(
                    attr.organisation,
                    filterFieldId + "-" + attr.organisation,
                    "Betreiber",
                    organisationOptionen.data,
                    "bezeichnung",
                    "id",
                    organisationOptionen.loading
                )}
                {formFactory.renderInput(
                    attr.betriebsBezeichnung,
                    filterFieldId + "-" + attr.betriebsBezeichnung,
                    "Betriebsbezeichnung"
                )}
                {formFactory.renderAutocompletePersonalisiert(
                    attr.betriebTyp,
                    filterFieldId + "-" + attr.betriebTyp,
                    "Betriebstyp",
                    betriebTypOptionen.data,
                    "value",
                    "id",
                    betriebTypOptionen.loading,
                    false,
                    false,
                    null,
                    null,
                    betriebstypPersonalisiert,
                    (value) => {
                        filterBetreiber(value);
                    }
                )}
                {formFactory.renderInput(
                    attr.anlagenBezeichnung,
                    filterFieldId + "-" + attr.anlagenBezeichnung,
                    "Abwasseranlagenbezeichnung"
                )}
            </div>
            <ErweiterteSucheJahresbericht
                sharedFilter={sharedFilter}
                onExtendedSearchOpenChanged={onErweiterteSucheOpenChanged}
                sharedFormFactory={sharedFormFactory}
                regionalstelleOptionen={regionalstelleOptionen}
                raeumlichesKriteriumOptionen={raeumlichesKriteriumOptionen}
                behoerdeOptionen={behoerdeOptionen}
                additionalPrefixFields={[

                ]}
            />
            <EAButtonBar style={{marginTop: "var(--buttonBar-spacing-top)"}}>
                <EAButton
                    id={filterFieldId + "-reset"}
                    label="Zurücksetzen"
                    onClick={() => {
                        setStoredFilter(initialSearchParameters);
                        setFilter(initialSearchParameters);
                        executeSearch(initialSearchParameters, sharedFilter);
                    }}
                />
                <EAButton id={filterFieldId + "-submit"} label="Suchen"
                          onClick={() => {
                              let newStoredFilter = {...filter, pageInfo: {...storedFilter.pageInfo, page: 0}};
                              setStoredFilter(newStoredFilter);
                              setSelected([]);
                              executeSearch(newStoredFilter, sharedFilter);
                          }}
                          color="primary"/>
            </EAButtonBar>
        </EAFieldset>
    );
}
